import { combineReducers } from "redux";
import notificaciones from "./notificaciones";
import mensajes from "./mensajes";
import usuario from "./usuario";
import lista from "./lista";
import diasjefe from "./diasjefe";
import dias from "./dias";
import anticipos from "./anticipos";
import elementos from "./elementos";
import equipos from "./equipos";
import vehiculo from "./vehiculo";

const rootReducer = combineReducers({
  notificaciones,
  mensajes,
  usuario,
  lista,
  diasjefe,
  dias,
  anticipos,
  elementos,
  equipos,
  vehiculo,
});
export default rootReducer;
